import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';

import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { CIPStatusItemDocument } from 'Views/Page/Content/Templates/WizardTemplates/CIPStatusItemDocumentUpload/Content';
import CheckCircleRounded from '@material-ui/icons/CheckCircleRounded';
import ErrorIcon from '@material-ui/icons/Error';
import classNames from 'classnames';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '400px',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  rootDesktop: {
    maxWidth: '600px',
  },
  main: {
    maxWidth: '100%',
  },
  fileItem: {
    marginTop: theme.spacing(2),
    maxWidth: '90%',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3.5),
  },
  labelContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  errorIcon: {
    fontSize: theme.typography.fontSize1Pt625Rem,
    color: theme.palette.facet.red,
    marginRight: theme.spacing(1),
  },
  successIcon: {
    fontSize: theme.typography.fontSize1Pt625Rem,
    color: theme.palette.success.main,
    marginRight: theme.spacing(1),
  },
  applicant: {
    marginBottom: theme.spacing(3),
  },
  documentCategory: {
    marginBottom: theme.spacing(2),
  },
  documentCategoryName: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  documentList: {
    display: 'flex',
  },
  documentContainer: {
    width: '100%',
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
});

const Content = ({
  classes,
}) => {
  const isMobile = useMobileLayout();
  const {
    resource,
  } = useMetaLayoutContext();
  const {
    refreshPageContentCollection,
  } = usePageContentContext();

  return (
    <div className={classNames(classes.root, {
      [classes.rootDesktop]: !isMobile,
    })}
    >
      <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} />
      <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
      <div className={classes.main}>{resource.attr('applicants').resources().list().map(applicant => {
        return (
          <div key={applicant.id()} className={classes.applicant}>
            <div className={classes.labelContainer}>
              {applicant.attr('isAppealable') === 'true' ? <CheckCircleRounded className={classes.successIcon} /> : <ErrorIcon className={classes.errorIcon} />}
              <Typography color="primary" weight="bold" variant="h3">{applicant.attr('name')}</Typography>
            </div>
            {applicant.attr('documentsByCategory').resources().list().map(documentsCategory => (
              <div key={documentsCategory.id()} className={classes.documentCategory}>
                <Typography weight="bold" variant="h5" className={classes.documentCategoryName}>{documentsCategory.attr('name')}</Typography>
                <div className={classes.documentList}>{documentsCategory.attr('documents').resources().list().map(document => (
                  <div className={classes.documentContainer}><CIPStatusItemDocument
                    key={document.id()}
                    onDelete={refreshPageContentCollection}
                    document={document}
                    isUploaded={documentsCategory.attr('isUploaded')}
                    onAfterUpload={refreshPageContentCollection}
                  />
                  </div>
                ))}
                </div>
              </div>))}
          </div>
        );
      })}
      </div>
    </div>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
